module.exports = __webpack_public_path__ + "img/success.58d728fb.png";